import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  timelinePlayBarPlaceholder: {
    height: '72px',
    width: '100%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    zIndex: 9999,

    '@media screen and (min-width: 1441px)': {
      height: '88px',
    },
  },
}));

export default useStyles;
